// extracted by mini-css-extract-plugin
module.exports = {"box":"person_box__1bLEz","model":"person_model__2Hw8y","back":"person_back__19got"};